import { SearchTerm } from "./SearchTerm";

const AbsenteeismCurrentWeekReportSearch: SearchTerm[] = [
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "mstDisplayname",
        translationKey: "displayName"
    },
    {
        heading: "Department",
        accessor: "department",
        searchOnName: "deptName",
        translationKey: "department"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },]

export default AbsenteeismCurrentWeekReportSearch;
